import React, { useEffect } from "react";
import { Main, Content } from "../../../components/Layout";
import { useParams } from "react-router-dom";
import useWrapper from "../../../hooks/useWrapper";
import AttendanceChat from "../../../components/AttendanceChat";

export default function AttendanceMessage() {
  const { attendanceId } = useParams();
  const { setbreadcrumb } = useWrapper();
  useEffect(() => {
    setbreadcrumb([{ label: "Atendimentos", url: "/attendance" }, { label: `Atendimento ${attendanceId}` }]);
  }, []);

  return (
    <Main>
      <Content>
        <AttendanceChat id={attendanceId} />
      </Content>
    </Main>
  );
}
